import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TableComponent} from 'common-shared';
import {take, takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {
  FilterModel,
  Page, PRIVILEGES
} from "common-shared";
import {saveAs} from 'file-saver';
import {BehaviorSubject} from "rxjs";
import {ResourceListFilter} from "../models/resource.query";
import {ResourceService} from "../resource.service";

@Component({
  selector: 'app-web-resource-list',
  templateUrl: './resource-list.component.html'
})
export class ResourceListComponent extends TableComponent implements OnInit {
  filter: FilterModel<ResourceListFilter> = new FilterModel<ResourceListFilter>({
    Data: new ResourceListFilter(),
    Page: new Page()
  });
  search$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(private resourceService: ResourceService, private router: Router, public changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
  }

  goToAdd(){
    this.router.navigate(['./manufacturing/resource/add']).catch(reason => console.error(reason));
  }

  public saveExcel() {
    this.resourceService.downloadExcel(this.filter).pipe(take(1), takeUntil(this.componentDestroyed)).subscribe(value => {
      saveAs(value.data, value.fileName);
    });
  }

  runChangeDetector() {
    this.changeDetector.detectChanges();
  }

  open($event: string) {
    this.router.navigate(['/manufacturing/resource/edit', $event]);
  }
}
